import { Card, CardContent, Typography } from '@mui/material';


export default function InstallComponent() {
  return (
    <Card sx={{ minWidth: 275, wordWrap: 'break-word' }}>
      <CardContent sx={{ wordWrap: 'break-word' }}>
        <Typography variant='body1' sx={{marginBottom: 1}}>The Sentient Sims App handles installing and updating the mod, as well as connecting to and configuring AI services.</Typography>
      </CardContent>
    </Card>
  )
}
